import { render, staticRenderFns } from "./SharePayDialog.vue?vue&type=template&id=52f70fe2&scoped=true&"
import script from "./SharePayDialog.vue?vue&type=script&lang=js&"
export * from "./SharePayDialog.vue?vue&type=script&lang=js&"
import style0 from "./SharePayDialog.vue?vue&type=style&index=0&id=52f70fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f70fe2",
  null
  
)

export default component.exports